import { PRESALE_CONTRACT_ADDRESS } from "../../../constants";
import { presaleAbi } from "../../../abis/presaleAbi";
import { useAccount, useReadContract } from "wagmi";

export function useClaimableAmount(presaleId: bigint) {
  const { address} = useAccount();

  const { data, error, isLoading, refetch: refetchClaimableAmount } = useReadContract({
    address: PRESALE_CONTRACT_ADDRESS,
    abi: presaleAbi,
    functionName: "claimableAmount",
    args: [address as `0x${string}`, presaleId]
  });

  if (isLoading) return null;

  if (error) {
    console.log(error);
    return null;
  }

  if (data === undefined || !refetchClaimableAmount) return null;

  const claimableAmount =(Number(data * BigInt(100) / BigInt(10**18)) / 100); 

  return { claimableAmount, refetchClaimableAmount, isLoading };
}